module.exports = __webpack_public_path__ + "ac9d5994149cd757351c67a6434828a9.svg";